<template>
  <b-row>
    <b-col cols="12" class="container min-vh-100">
      <b-card class="">
        <b-row class="m-1">
          <b-col cols="12">
            <hr class="my-12 bg-dark" />
          </b-col>
          <!-- <b-col cols="4" class="my-1">
        <span>เลขรับเรื่อง</span>
      </b-col>
      <b-col cols="8" class="my-1">{{ model.complaintCode }}</b-col>
      <b-col cols="12">
        <hr class="my-12 bg-dark" />
      </b-col> -->

          <b-col cols="12"><b class="">ข้อมูลผู้ร้องทุกข์</b></b-col>
          <b-col cols="12">
            <hr class="my-12 bg-dark" />
          </b-col>

          <b-col cols="4" md="3" class="my-1">
            <b>การยืนยันนัดหมาย</b>
          </b-col>
          <b-col cols="8" md="3" class="my-1">{{
            model.isAppointmentNeedConfirm === true
              ? "ต้องยืนยันนัดหมาย"
              : "ไม่ต้องยืนยันนัดหมาย"
          }}</b-col>

          <b-col cols="4" md="3" class="my-1">
            <b>วันที่นัดหมาย</b>
          </b-col>
          <b-col cols="8" md="3" class="my-1"
            >{{ model.appointmentCustomerDateStr }} เวลา
            {{ model.appointmentCustomerStartTime }} -
            {{ model.appointmentCustomerEndTime }} น.</b-col
          >

          <b-col cols="4" md="3" class="my-1">
            <b>สถานที่</b>
          </b-col>
          <b-col cols="8" md="3" class="my-1">{{
            model.customerMediateStr
          }}</b-col>

          <b-col
            v-if="model.customerMediate !== false"
            cols="12"
            md="3"
            class="my-1"
            ><a :href="model.customerMediateMeetingUrl" target="_blank"
              >Link Conferrence</a
            ></b-col
          >

          <b-col cols="12">
            <hr class="my-12 bg-dark" />
          </b-col>
          <b-col cols="12"><b class="">ข้อมูลผู้ถูกร้องทุกข์</b></b-col>
          <b-col cols="12">
            <hr class="my-12 bg-dark" />
          </b-col>

          <b-col cols="4" md="3" class="my-1">
            <b>การยืนยันนัดหมาย</b>
          </b-col>
          <b-col cols="8" md="3" class="my-1">{{
            model.isAppointmentNeedConfirm === true
              ? "ต้องยืนยันนัดหมาย"
              : "ไม่ต้องยืนยันนัดหมาย"
          }}</b-col>

          <b-col cols="4" md="3" class="my-1">
            <b>วันที่นัดหมาย</b>
          </b-col>
          <b-col cols="8" md="3" class="my-1"
            >{{ model.appointmentCompanyDateStr }} เวลา
            {{ model.appointmentCompanyStartTime }} -
            {{ model.appointmentCompanyEndTime }} น.</b-col
          >

          <b-col cols="4" md="3" class="my-1">
            <b>สถานที่</b>
          </b-col>
          <b-col cols="8" md="3" class="my-1">{{
            model.companyMediateStr
          }}</b-col>

          <b-col
            v-if="model.companyMediate !== false"
            cols="12"
            md="3"
            class="my-1"
            ><a :href="model.companyMediateMeetingUrl" target="_blank"
              >Link Conferrence</a
            ></b-col
          >
          <b-col cols="12">
            <hr class="my-12 bg-dark" />
          </b-col>
        </b-row>

        <b-col class="container text-right mt-n2">
          <b-button
            v-if="model.committeeStatus !== 2"
            variant="outline-primary"
            class="ml-1 my-2"
            @click="onSelectCommitteeClicked"
          >
            <feather-icon icon="PlusIcon" class="mr-25" />
            <span>เลือกอนุกรรมการ</span>
          </b-button>
          <div v-else class="pt-2"></div>
        </b-col>

        <!-- table -->
        <vue-good-table
          :columns="columns"
          :rows="rows"
          :line-numbers="true"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm,
          }"
          :select-options="{
            enabled: false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
            selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }"
          :pagination-options="{
            enabled: true,
            perPage: pageLength,
          }"
        >
          <template slot="table-row" slot-scope="props">
            <!-- Column: Name -->
            <span v-if="props.column.field === 'fullName'" class="text-nowrap">
              <span class="text-nowrap">{{
                props.row.committeeData != null
                  ? props.row.committeeData.firstname +
                    " " +
                    props.row.committeeData.lastname
                  : ""
              }}</span>
            </span>

            <!-- Column: Name -->
            <span v-if="props.column.field === 'groupName'" class="text-nowrap">
              <span class="text-nowrap">{{
                props.row.committeeData != null &&
                props.row.committeeData.directorGroup != null
                  ? props.row.committeeData.directorGroup.name
                  : ""
              }}</span>
            </span>

            <!-- Column: Name -->
            <span
              v-if="props.column.field === 'directorPositionName'"
              class="text-nowrap"
            >
              <span class="text-nowrap">{{
                props.row.committeeData != null
                  ? props.row.committeeData.directorPositionName
                  : ""
              }}</span>
            </span>

            <!-- Column: Name -->
            <span
              v-if="props.column.field === 'divisionName'"
              class="text-nowrap"
            >
              <span class="text-nowrap">{{
                props.row.committeeData != null
                  ? props.row.committeeData.divisionName
                  : ""
              }}</span>
            </span>

            <!-- Column: Name -->
            <span v-if="props.column.field === 'tel'" class="text-nowrap">
              <span class="text-nowrap">{{
                props.row.committeeData != null
                  ? props.row.committeeData.tel
                  : ""
              }}</span>
            </span>

            <!-- Column: Name -->
            <span v-if="props.column.field === 'mobile'" class="text-nowrap">
              <span class="text-nowrap">{{
                props.row.committeeData != null
                  ? props.row.committeeData.mobile
                  : ""
              }}</span>
            </span>

            <!-- Column: Name -->
            <span v-if="props.column.field === 'email'" class="text-nowrap">
              <span class="text-nowrap">{{
                props.row.committeeData != null
                  ? props.row.committeeData.email
                  : ""
              }}</span>
            </span>

            <!-- Column: Name -->
            <span v-if="props.column.field === 'removeButton'" class="text-nowrap">
              <b-button
                :disabled="model.committeeStatus === 2"
                variant="danger"
                class="btn-sm"
                @click="onRemoveRow(props.row)"
              >
                <feather-icon icon="TrashIcon" /> ลบ
              </b-button>
            </span>

            <span v-if="props.column.field === 'isActive'" class="text-nowrap">
              <b-form-checkbox
                :disabled="model.committeeStatus === 2"
                class="custom-control-primary"
                v-model="props.row.isActive"
                @change="onIsActiveChange(props.row)"
                switch
              >
                <span class="switch-icon-left">
                  <feather-icon icon="CheckIcon" />
                </span>
                <span class="switch-icon-right">
                  <feather-icon icon="XIcon" />
                </span>
              </b-form-checkbox>
            </span>

            

            <span
              v-if="props.column.field === 'isDirector'"
              class="text-nowrap"
            >
              <b-form-checkbox
                :disabled="model.committeeStatus === 2"
                class="custom-control-primary"
                v-model="props.row.isDirector"
                @change="onIsDirectorChange(props.row)"
                switch
              >
                <span class="switch-icon-left">
                  <feather-icon icon="CheckIcon" />
                </span>
                <span class="switch-icon-right">
                  <feather-icon icon="XIcon" />
                </span>
              </b-form-checkbox>
            </span>

            <!-- Column: Common -->
            <!-- <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span> -->
          </template>

          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap ">
                  แสดง 1 ถึง
                </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['10', '50', '100']"
                  class="mx-1"
                  @input="
                    (value) => props.perPageChanged({ currentPerPage: value })
                  "
                />
                <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>

        <b-col class="container text-right">
          <b-button
            v-if="model.committeeStatus !== 2"
            variant="primary"
            class="ml-1 my-2"
            @click="onSubmitBtnClicked"
          >
            <feather-icon icon="PlusIcon" class="mr-25" />
            <span>บันทึกข้อมูล</span>
          </b-button>
        </b-col>
      </b-card>
    </b-col>
    <ModalAddCommitteeVue
      ref="ModalAddCommittee"
      @handle-submit="onModalSubmit"
    ></ModalAddCommitteeVue>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BPagination,
  BFormTextarea,
  BCard,
  BFormRadio,
  BFormSelect,
  BTab,
  BTabs,
  BButton,
  BFormInput,
  BFormGroup,
  BFormRadioGroup,
  BFormFile,
  BFormCheckbox,
  BOverlay,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import TableHeaders from "./components/committeeTableHeader.js";

import * as subcommitteeStore from "@/store/api/subcommittee/index.js";
import * as mediateDirectorStore from "@/store/api/mediate-director/index.js";
import * as mediateDirectorGroupStore from "@/store/api/mediate-director/group.js";
import * as masterStore from "@/store/api/master/index.js";
import * as storeFileUpload from "@/store/api/fileUpload/index.js";
import * as userData from "@/auth/localStorageUtils.js";

import VueSelect from "vue-select";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";

import ModalAddCommitteeVue from "./components/ModalAddCommittee.vue";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  message: "กรุณากรอก{_field_}",
  computesRequired: true,
});

export default {
  components: {
    BButton,
    BFormRadio,
    BFormSelect,
    BCard,
    BRow,
    BCol,
    BPagination,
    BFormTextarea,
    BTab,
    BTabs,
    BFormInput,
    BFormGroup,
    BFormRadioGroup,
    BFormFile,
    BFormCheckbox,
    BOverlay,
    ValidationObserver,
    ValidationProvider,
    VueSelect,
    VueGoodTable,
    ModalAddCommitteeVue,
  },
  data() {
    return {
      model: {
        committeeStatus: null,
      },
      pageLength: 10,
      columns: TableHeaders,
      rows: [],
      searchTerm: "",
    };
  },
  created() {
    const _this = this;
    /// id จะไม่มีทาง null
    this.getById(this.$route.query.id);
  },
  methods: {
    getById(id) {
      const _this = this;

      subcommitteeStore
        .getMeetingById(id)
        .then((response) => {
          _this.model = response.data.data;

          _this.getSelectedCommittee();
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getSelectedCommittee() {
      const _this = this;

      subcommitteeStore
        .getSearchCommitteeList(_this.model.docId)
        .then((response) => {
          _this.rows = response.data.data;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onSubmitBtnClicked() {
      const _this = this;

      this.$swal({
        title: "ยืนยันการบันทึกข้อมูล?",
        text: "",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {          
          const submitRows = _this.rows.map((row) => {
            console.log("row", row);
            return {
              directorId: row.committeeData.id,
              isActive: row.isActive,
              isDirector: row.isDirector,
            };
          });

          subcommitteeStore
            .updateData(submitRows, userData.userId(), _this.model.docId)
            .then((response) => {
              if (response.data.success === true) {
                _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                  title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                  variant: "success",
                  solid: false,
                });

                location.reload();
              } else {
                _this.$bvToast.toast(response.data.message, {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              }
            })
            .catch((error) => {
              console.log("error", error);
              _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                variant: "danger",
                solid: false,
              });
            });
        }
      });
    },
    onCancelBtnClicked() {
      window.open(
        this.$router.resolve({ name: "MediateDirector" }).href,
        "_self"
      );
    },
    onSelectCommitteeClicked() {
      this.$refs.ModalAddCommittee.$refs["modal-add-committee"].show();

      this.$refs.ModalAddCommittee.setModalData(
        this.rows,
        this.model.directorGroupId
      );
    },
    onModalSubmit(newSelectedRows, directorGroupId) {
      console.log("onModalSubmit", newSelectedRows);
      this.rows = newSelectedRows;
      this.model.directorGroupId = directorGroupId;
    },
    onIsDirectorChange(row) {
      console.log("onIsDirectorChange", row);
      this.rows.forEach((r) => {
        if (r.committeeData.id === row.committeeData.id) {
          r.isDirector = row.isDirector;
        }
      });
      // this.$refs.tableCommon[0].selectionChanged();
    },
    onIsActiveChange(row) {
      console.log("onIsActiveChange", row);
      this.rows.forEach((r) => {
        if (r.committeeData.id === row.committeeData.id) {
          r.isActive = row.isActive;
        }
      });
      // this.$refs.tableCommon[0].selectionChanged();
    },
    onRemoveRow(row) {
      console.log("onRemoveRow", row);
      this.rows = this.rows.filter((r) => r.committeeData.id !== row.committeeData.id);
    },
    selectOnInput() {
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
